import React from 'react';
import { Subscription } from '../core/_models';

interface Props {
  subscription: Subscription | null;
  show: boolean;
  onHide: () => void;
}

export const SubscriptionDetailsModal: React.FC<Props> = ({ subscription, show, onHide }) => {
  if (!show || !subscription) return null;

  return (
    <>
      <div className='modal fade show d-block' tabIndex={-1} role='dialog' aria-modal='true'>
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          <div className='modal-content bg-body'>
            <div className='modal-header border-bottom border-gray-200 dark:border-gray-700'>
              <h2 className='fw-bolder text-gray-900'>Detalhes da Assinatura</h2>
              <div className='btn btn-icon btn-sm btn-active-icon-primary' onClick={onHide}>
                <i className='bi bi-x fs-1'></i>
              </div>
            </div>

            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              <div className='d-flex flex-column mb-8'>
                <h4 className='text-gray-800 fw-bolder mb-4'>Cliente</h4>
                <div className='bg-light rounded p-4 d-flex justify-content-between align-items-center'>
                  <span className='fw-bold text-gray-800 fs-5'>{subscription.client?.user?.name || subscription.client?.nameResponsible || 'Desconhecido'}</span>
                  <span className='badge badge-light-primary fw-bolder fs-6 px-4 py-2'>{subscription.status}</span>
                </div>
              </div>

              <div className='d-flex flex-column mb-8'>
                <h4 className='text-gray-800 fw-bolder mb-4'>Plano / Faturamento</h4>
                <div className='bg-light rounded p-4'>
                  <div className='d-flex flex-stack mb-3'>
                    <span className='text-muted fw-bold'>Plano Contratado</span>
                    <span className='text-gray-800 fw-bolder'>{subscription.plan?.name}</span>
                  </div>
                  <div className='d-flex flex-stack mb-3'>
                    <span className='text-muted fw-bold'>Periodicidade</span>
                    <span className='text-gray-800 fw-bolder'>{subscription.cycle}</span>
                  </div>
                  <div className='d-flex flex-stack mb-3'>
                    <span className='text-muted fw-bold'>Valor Mensal</span>
                    <span className='text-gray-800 fw-bolder fs-5'>
                      R$ {Number(subscription.monthly_value).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </span>
                  </div>
                  <div className='d-flex flex-stack'>
                    <span className='text-muted fw-bold'>Data de Início</span>
                    <span className='text-gray-800 fw-bolder'>
                      {subscription.start_date 
                        ? new Date(subscription.start_date).toLocaleDateString('pt-BR') 
                        : 'Não iniciada'}
                    </span>
                  </div>
                </div>
              </div>

              <div className='text-center pt-10'>
                <button type='button' className='btn btn-primary' onClick={onHide}>
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  );
};
